import './styles.css'

interface IAllQuestionBookItems {
  _id: string
  questionBookName: string
  questionNumber: number
  title: string
  alternatives: IAlternatives[]
}

interface IAlternatives {
  _id: string
  answer: string
  letter: string
  right: boolean
}

interface IProps {
  allQuestionBookItems: IAllQuestionBookItems[]
  questionBookPrintRef: React.MutableRefObject<HTMLDivElement>
}

const PrintPDF = (props: IProps) => {
  const { allQuestionBookItems, questionBookPrintRef } = props

  return (
    <div ref={questionBookPrintRef} className="page">
      <b>
        <div className="title">{allQuestionBookItems[0]?.questionBookName}</div>
      </b>
      {allQuestionBookItems?.length &&
        allQuestionBookItems?.map((a) => (
          <div className="questionContainer" key={a.questionNumber}>
            <div className="questionBody">
              <div
                dangerouslySetInnerHTML={{ __html: a.title?.replace(/\\[n|r|t]/g, '<br>') }}
                id={`question-option-${a._id}`}
              />
            </div>
            {a.alternatives?.map((alt) => (
              <div className="questioAlternativesContainer" key={alt.letter}>
                <span className="questioAlternativeLetter">{alt.letter} )</span>
                <div
                  dangerouslySetInnerHTML={{ __html: alt.answer?.replace(/\\[n|r|t]/g, '<br>') }}
                  id={`question-option-${alt._id}`}
                />
              </div>
            ))}
          </div>
        ))}
    </div>
  )
}

export default PrintPDF
